export default __webpack_public_path__ + "static/media/Menuicon.d7a5d819.svg";